import { Link as InertiaLink } from '@inertiajs/react'

import { PageLayout } from '@components/layouts/PageLayout'
import Icon from '@components/utils/Icon'

/**
 * Previews index (design-phase only).
 *
 * Lists the prototype preview pages the current user is allowed to open, each
 * linking to its show action. Driven entirely by props from PreviewsController.
 */

type PreviewPage = { slug: string; title: string; href: string }

const PreviewsIndex = ({ pages }: { pages: PreviewPage[] }) => {
  return (
    <PageLayout.Root>
      <PageLayout.Header heading="Previews" />
      <PageLayout.Body>
        <p className="tw:mb-4 tw:text-sm tw:text-gray-600">
          Design-phase preview pages. These are prototypes for review and are not part of the product.
        </p>

        {pages.length === 0 ? (
          <p className="tw:text-sm tw:text-gray-500">No previews are enabled for your account.</p>
        ) : (
          <ul className="tw:flex tw:flex-col tw:gap-2">
            {pages.map((page) => (
              <li key={page.slug}>
                <InertiaLink
                  href={page.href}
                  className="tw:flex tw:items-center tw:justify-between tw:rounded-lg tw:border tw:border-gray-200 tw:bg-white tw:px-4 tw:py-3 tw:shadow-xs tw:transition-colors tw:hover:border-primary-300"
                >
                  <span className="tw:font-medium tw:text-gray-900">{page.title}</span>
                  <Icon type="arrow-circle-broken-right" className="tw:h-5 tw:w-5 tw:text-primary-600" />
                </InertiaLink>
              </li>
            ))}
          </ul>
        )}
      </PageLayout.Body>
    </PageLayout.Root>
  )
}

export default PreviewsIndex
